<template>
<div><br>
  <!-- <span v-if="testObject" v-text="testObject" ></span> -->

<!-- https://serversideup.net/uploading-files-vuejs-axios/ -->

<!-- <template v-for="tour in toursList">
  <ul>
      <li><router-link tag="a" :to="'/reservar/'+tour.id"> <font-awesome-icon icon="users" /> {{tour.nombre}}</router-link></li>
  </ul>
</template> -->

  <div class="tabs is-toggle is-toggle-rounded">
        <ul>
          <li @click="subSelect = 1,fecha2='',tour2='',fecha3='',tour3='',fecha4='',tour4=''" :class="(subSelect == 1) ? 'is-active' : '' ">
            <a>
              <span class="icon is-small"><i class="fas fa-image"></i></span>
              <span>1 día</span>
            </a>
          </li>
          <!-- <li id="2" v-bind:class="tipoCuponF('2')"> -->
          <li @click="subSelect = 2,fechas(2),fecha3='',tour3='',fecha4='',tour4=''" :class="(subSelect == 2) ? 'is-active' : '' ">
            <a>
              <span class="icon is-small"><i class="fas fa-music"></i></span>
              <span>Combo 2</span>
            </a>
          </li>
          <li @click="subSelect = 3,fechas(3),fecha4='',tour4=''" :class="(subSelect == 3) ? 'is-active' : '' ">
            <a>
              <span class="icon is-small"><i class="fas fa-film"></i></span>
              <span>Combo 3</span>
            </a>
          </li>
          <li @click="subSelect = 4,fechas(4)" :class="(subSelect == 4) ? 'is-active' : '' ">
            <a>
              <span class="icon is-small"><i class="fas fa-file-alt"></i></span>
              <span>Combo 4</span>
            </a>
          </li>
        </ul>
      </div>
  <div class="columns">
    <div class="column is-5" style="background-color:#BCF5A9;" >
      <p> Reservación </p>
      <!-- <label style="font-size:40px;">
        Puestos
      </label>
      <label> Departamento de usuario: {{$cookies.get('RhSession').id_depar}} </label> -->

      <!-- {{puestos}} -->

      

      

      <div class="section" v-if="subSelect==1 || subSelect==2 || subSelect==3 || subSelect==4 ">

        <div class="columns">
          <div class="column">
            <div class="field">
              <label>Tour</label><br>
              <div class="select is-fullwidth">
                <select v-model="tour" @change="getTipos">
                  <option class="is-size-7" v-for="tour in toursList" :key="tour.id" :value="tour">{{tour.nombre}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        
        <div class="columns">

          <div class="column">
              <div class="field" style="z-index: 9;">
                <label>Fecha</label><br>
                <date-pick v-model="fecha"></date-pick>
              </div>
          </div>
              
          <div class="column">
            <div class="field" v-if=" tour ">
              <label>Cortesía</label><br>
              <div class="select is-fullwidth">
                <select v-model="cortesia">
                  <option value=1>Si</option>
                  <option value=2>No</option>
                </select>
              </div>
            </div>
          </div>

        </div>

        <div class="columns">

          <div class="column">
            <div class="field" v-if=" tour.operador_id==2 ">
              <label>Horario</label><br>
              <div class="select is-fullwidth">
                <select v-model="horario">
                  <option value=1>Primer horario</option>
                  <option value=2>Segundo horario</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="field" v-if=" tour.operador_id==2 || tour.operador_id == 1 ">
              <label>Servicio</label><br>
              <div class="select is-fullwidth">
                <select v-model="servicio">
                  <option value=1>General</option>
                  <option value=2>Privado</option>
                </select>
              </div>
            </div>
          </div>

        </div>

        <div class="columns">

          <div class="column" v-if="subSelect==2 || subSelect==3 || subSelect==4 ">
            <div class="field">
              <label>Tour 2</label><br>
              <div class="select is-fullwidth">
                <select v-model="tour2">
                  <option v-for="tour in toursList" :key="tour.id" v-if="tour.operador_id==2" :value="tour">{{tour.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="field" style="z-index: 9;">
                <label>Fecha 2</label><br>
                <date-pick v-model="fecha2"></date-pick>
              </div>
          </div>

          <div class="column" v-if="subSelect==3 || subSelect==4">
            <div class="field">
              <label>Tour 3</label><br>
              <div class="select is-fullwidth">
                <select v-model="tour3">
                  <option v-for="tour in toursList" :key="tour.id" v-if="tour.operador_id==2" :value="tour">{{tour.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="field" style="z-index: 9;">
                <label>Fecha 3</label><br>
                <date-pick v-model="fecha3"></date-pick>
            </div>
          </div>

        </div>

        <div  v-if="subSelect==4">
            <div class="field">
              <label>Tour 4</label><br>
              <div class="select is-fullwidth">
                <select v-model="tour4">
                  <option v-for="tour in toursList" :key="tour.id" v-if="tour.operador_id==2" :value="tour">{{tour.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="field" style="z-index: 9;">
                <label>Fecha 4</label><br>
                <date-pick v-model="fecha4"></date-pick>
            </div><br>
          </div>

        

        <div class="columns">

          <div class="column">
            <div class="field" v-if="(tiposList.length>0 || tiposGeneralesList.length>0) && tour ">
              <label>Tipo de tour</label><br>
              <div class="select is-fullwidth">
                <select v-model="tipo">
                  <option v-if="tiposList=='no hay datos' || tour.id==6" v-for="tipo in tiposGeneralesList" :key="tipo.id" :value="tipo.id">{{tipo.nombre}}</option>
                  <option v-if="tiposList!='no hay datos'" v-for="tipo in tiposList" :key="tipo.id" :value="tipo.id">{{tipo.nombre}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column" v-if="tour">
            <div class="field">
              <label>Desde</label><br>
              <div class="select is-fullwidth">
                <select v-model="salida">
                  <option v-for="salida in salidasList" :key="salida.id" :value="salida.id" >{{salida.nombre}}</option>
                </select>
              </div>
            </div>
          </div>

        </div>

        <div class="columns">

          <div class="column">
            <div class="field" v-if="tour">
              <label>Nacionalidad</label><br>
              <div class="select is-fullwidth">
                <select v-model="nacionalidad">
                  <option v-for="nacionalidad in nacionalidadesList" :key="nacionalidad.id" :value="nacionalidad.id" >{{nacionalidad.nombre}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="field" v-if="nacionalidad!==1 && nacionalidad!==''">
              <label>Idioma</label><br>
              <div class="select is-fullwidth">
                <select v-model="idioma">
                  <option v-for="idioma in idiomasList" :key="idioma.id" :value="idioma.id" >{{idioma.nombre}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">

          <div class="column">
            <label>Adultos</label>
            <input class="input" v-model="adultos" type="number" >
          </div>

          <div class="column">
            <label>Niños</label>
            <input class="input" v-model="ninos" type="number" >
          </div>

          <div class="column">
            <label>Infantes</label>
            <input class="input" v-model="infantes" type="number" >
          </div>

        </div>

        <div class="field">
          <input class="input" v-model="cliente" placeholder="Nombre del cliente">
        </div>

        <div class="field"><label v-if="this.hotel!=''"> {{this.hotel}} </label>
          <input v-model="searchText" placeholder="Buscar hotel ..." class="input">
          <br>
            <!-- <div> -->
              <template v-for="item in itemsSearched">
                <li v-if="searchText!=''" v-text="item.nombre" :key="item.id" @click="elegido(item),hotel=item.nombre"></li><br v-if="searchText!=''" :key="item.id">
              </template>
            <!-- </div> -->
          <!-- <div class="select is-multiple">
            <select multiple v-model="hotel" v-if="searchText" @change="elegido(hotel[0])">
              <option v-for="item in itemsSearched" :value="item">{{ item.nombre }}</option>
            </select>
          </div> -->
        </div>

        <div class="columns">

          <div class="column">
            <label>Habitación</label>
            <input class="input" v-model="habitacion" >
          </div>

          <div class="column">
            <label>Cupón</label>
            <input class="input" v-model="cupon" >
          </div>

          

        </div>

        <div class="columns">

          <div class="column">
            <div class="field">
              <label>Hora de pickup</label>
              <vue-clock-picker class="time" mode="24" v-model="hora"></vue-clock-picker>
            </div>
          </div>

          <div class="column">
            <div class="field"><label v-if="this.vendedor!=''"> {{this.vendedor}} </label> <label v-else>Vendedor</label>
              <input v-model="searchText2" placeholder="Buscar Vendedor..." class="input">
              <br>
              <template v-for="item in itemsSearched2">
                <li v-if="searchText2!=''" v-text="item.nombre" :key="item" @click="elegido2(item),vendedor=item.nombre"></li><br v-if="searchText!=''" :key="item.nombre">
              </template>
              <!-- <div class="select is-multiple">
                <select multiple v-model="vendedor" v-if="searchText2" @change="elegido2(vendedor[0])">
                <option v-for="item in itemsSearched2" :value="item">{{ item.nombre }}</option>
                </select>
              </div> -->
            </div>
          </div>

        </div>

        <div class="columns">
          <div class="column">
            <label>Balance</label>
            <input class="input" v-model="balance" type="number">
          </div>

          <div class="column"><label>Moneda</label><br>
            <div class="select is-fullwidth">
              <select v-model="moneda">
                <option v-for="moneda in monedasList" :value="moneda.id" >{{moneda.nombre}}</option>
              </select>
            </div>
          </div>
        </div>

        <textarea class="textarea" v-model="observaciones" placeholder="Observaciones"></textarea>

        <a v-if="vendedor && fecha && tour.id && tipo && salida && nacionalidad && adultos && cliente && hotelId && hora && subSelect==1" @click="reservar" class="button is-info">Reservar</a>
        <a v-if="vendedor && fecha && tour.id && fecha2 && tour2.id && tipo && salida && nacionalidad && adultos && cliente && hotelId && hora && subSelect==2" @click="reservar" class="button is-info">Reservar Combo 2</a>
        <a v-if="vendedor && fecha && tour.id && fecha2 && tour2.id && fecha3 && tour3.id && tipo && salida && nacionalidad && adultos && cliente && hotelId && hora && subSelect==3" @click="reservar" class="button is-info">Reservar Combo 3</a>
        <a v-if="vendedor && fecha && tour.id && fecha2 && tour2.id && fecha3 && tour3.id && fecha4 && tour4.id && tipo && salida && nacionalidad && adultos && cliente && hotelId && hora && subSelect==4" @click="reservar" class="button is-info">Reservar Combo 4</a>
        

      </div>
      

      

      

    </div>
  
      <div>
        
        <div id="modalConfirmacion" class="modal" align="center">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <span class="modal-card-title">
                <strong>Número de confirmación</strong>
              </span>
              <button class="delete" @click="cerrarModalConfirmacion" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
              <strong><span class="is-size-2" v-text="this.confirma" ></span></strong>
              <br>
              Cliente: <strong><span v-text="this.cliente"></span></strong><br>
              Vendedor: <strong><span v-text="this.vendedor"></span></strong><br>
              Tour: <strong><span v-text="this.tour.nombre"></span></strong><br>

            </section>
            <footer class="modal-card-foot">
              <button @click="cerrarModalConfirmacion" class="button is-info">Entendido</button>
            </footer>
          </div>
        </div> 

      </div>
  </div>

</div>
</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'

export default {
  components:{
    DatePick,
    VueClockPicker
  },
  data () {
    return {
      subSelect:'',
      toursList:[],
      tiposList:[],
      tiposGeneralesList:[],
      idiomasList:[],
      nacionalidadesList:[],
      salidasList:[],
      tour:'',
      tour2:'',
      tour3:'',
      tour4:'',
      tipo:'',
      nacionalidad:'',
      idioma:'',
      salida:'',
      fecha:moment().add(1, 'day').format('YYYY-MM-DD'),
      fecha2:'',
      fecha3:'',
      fecha4:'',
      hora:'',
      searchText:'',
      searchText2:'',
      items:[],
      items2:[],
      hotel:'',
      hotelId:'',
      hotelPickup:'',
      vendedor:'',
      vendedorId:null,
      adultos:2,
      ninos:0,
      infantes:0,
      cliente:'',
      habitacion:'',
      cupon:'',
      balance:0,
      moneda:null,
      monedasList:[],
      observaciones:'',
      confirma:'',
      servicio:1,
      horario:1,
      cortesia:2,
      testObject:[],
      files: '',
      imagen: null,
      host: 'booking.sistemy.mx'
      // host: 'localhost'

    }
  },
  created(){
    this.getTiposGenerales();
    this.getHoteles();
    this.getVendedores();
    this.getMonedas();
    this.getTours();
    this.getIdiomas();
    this.getNacionalidades();
    this.getSalidas();
    // this.test();
  },
  computed:{
    itemsSearched : function(){
      var self = this;
      if( self.searchText == ''){
        return self.items;
      }
      return self.items.filter(function(item){

        var str = self.searchText;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    },
    itemsSearched2 : function(){
      var self = this;
      if( self.searchText2 == ''){
        return self.items2;
      }
      return self.items2.filter(function(item){

        var str = self.searchText2;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    }
  },
  methods:{
    clear () {
      console.log("limpiando form");
      this.subSelect=1;
      this.tour='';
      this.tour2='';
      this.tour3='';
      this.tour4='';
      this.tipo='';
      this.nacionalidad='';
      this.idioma='';
      this.salida='';
      this.fecha=moment().add(1, 'day').format('YYYY-MM-DD');
      this.fecha2='';
      this.fecha3='';
      this.fecha4='';
      this.hora='';
      this.searchText='';
      this.searchText2='';
      this.hotel='';
      this.hotelId='';
      this.hotelPickup='';
      this.vendedor='';
      this.vendedorId=null;
      this.adultos=2;
      this.ninos=0;
      this.infantes=0;
      this.cliente='';
      this.habitacion='';
      this.cupon='';
      this.balance=0;
      this.moneda=null;
      this.observaciones='';
      this.confirma='';
      this.servicio=1;
      this.horario=1;
      this.cortesia=2;
    },
    test(){
      console.log("En test");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'reservaciones',
          where: ''
      }
          axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ console.log(response,'<-- response de test')
         if (response.status == 200 ) { console.log("bien test");
         this.testObject=response
           this.$snotify.success('test', 'Correcto', {
               timeout: 4000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });

    },
    fechas (r) {
      if(r==2){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      }else if (r==3){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
        this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
      }else if(r==4){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
        this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
        this.fecha4=moment().add(4, 'days').format('YYYY-MM-DD');
      }
    },
    reservar () {
      console.log("reservar 1");
      var estancia=this;
      var posicion=1;
      if(this.ninos==null){
        var confirmacion = this.vendedor.substr(0,2)+this.tour.nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+this.adultos+'-'+$cookies.get('RhSession').name.substr(0,1).toUpperCase();
      }else{
        var confirmacion = this.vendedor.substr(0,2)+this.tour.nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+this.adultos+'-'+this.ninos+$cookies.get('RhSession').name.substr(0,1).toUpperCase();
      }
      this.confirma=confirmacion;
      $("#modalConfirmacion").addClass("is-active");
      console.log(confirmacion);
      var params = {
        action : 'insertPost',
        table : 'reservaciones',
        columns : 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion, servicio, cortesia, horario',
        values : ` ${$cookies.get('RhSession').id}, '${estancia.fecha}',${estancia.tour.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}',${estancia.servicio},${estancia.cortesia},${estancia.horario} `
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });

       if(this.subSelect==2 || this.subSelect==3 || this.subSelect==4){
         var posicion=2;
         console.log("Insertando el día 2 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha2}',${estancia.tour2.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha2}',${estancia.tour2.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }

       if(this.subSelect==3 || this.subSelect==4){
         var posicion=3;
         console.log("Insertando el día 3 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha3}',${estancia.tour3.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha3}',${estancia.tour3.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }

       if(this.subSelect==4){
         var posicion=4;
         console.log("Insertando el día 4 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha4}',${estancia.tour4.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha4}',${estancia.tour4.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }
    },
    elegido:function(item){
      this.searchText='';
      this.hotel = item.nombre;
      this.hotelId = item.id;
      this.hotelPickup = item.pickup;
      console.log(this.tour.pickup,'tour.pickup');
      console.log(item,'item');
      if(this.tour.pickup=='' || this.tour.pickup==null ){
        this.hora=item.pickup;
      }
    },
    elegido2:function(item){
      this.searchText2='';
      this.vendedor = item.nombre;
      this.vendedorId = item.id;
    },
    getHoteles(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre, pickup',
        //   table: 'hoteles',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre, pickup`;
        var tabla = "hoteles";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            // estancia.hotelesList  = response.data;
            estancia.items = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getMonedas(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "monedas";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.monedasList = response.data;
            estancia.moneda=response.data[0].id;
          }else{
            console.log('error');
          }
        });
    },
    getVendedores(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'vendedores',
        //   where: 'activo=1',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "vendedores";
        var where = "activo=1";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.items2 = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getTours(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"tour",
      //     where:``,
      //     condition:" order by nombre "
      //   })
      var select = `*`;
      var tabla = "tour";
      var where = "";
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.toursList=response.data;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getTipos(){
      console.log(this.tour,'tour');
      this.hora=this.tour.pickup;
      console.log(this.hora,'hora');
      if(this.tour!=''){
        var estancia=this;
        // axios.post('http://localhost:3000/justRead',{
        //     select:` * `,
        //     table:"tipo",
        //     where:` tourId like '%,${estancia.tour.id},%' `,
        //     condition:""
        //   })
        var select = `*`;
        var tabla = "tipo";
        var where = ` tourId like '%25%2C${estancia.tour.id}%2C%25' `;
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposList=response.data;
                if(estancia.tour.id!=6){
                  console.log(response,'response getTipos')
                  estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
      }
    },
    getTiposGenerales(){
      console.log("en reservar")
        var estancia=this;
        // axios.post('http://localhost:3000/justRead',{
        //     select:` * `,
        //     table:"tipo",
        //     where:` tourId = "0" `,
        //     condition:""
        //   })
        var select = `*`;
        var tabla = "tipo";
        var where = "tourId = '0'";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposGeneralesList=response.data;
                if(estancia.tipo==''){
                // if(estancia.tipo=='' || (estancia.tiposList.length<1 && tour.id==6) ){
                 estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    getIdiomas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"idioma",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "idioma";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.idiomasList=response.data;
              estancia.idioma=response.data[4].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getSalidas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"lugar_salida",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "lugar_salida";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.salidasList=response.data;
              estancia.salida=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getNacionalidades(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"nacionalidad",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "nacionalidad";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.nacionalidadesList=response.data;
              estancia.nacionalidad=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    tipoCuponF(n){
      if(this.tipoCupon==1){
        $("#1").addClass("is-active");
      }
      if(n==2){
        $("#2").addClass("is-active");
      }
      if(n==3){
        $("#3").addClass("is-active");
      }
      if(n==4){
        $("#4").addClass("is-active");
      }
      this.tipoCupon=n;
    },
    cerrarModalConfirmacion:function(){
      this.clear();
      $("#modalConfirmacion").removeClass("is-active");
    },
  },
  mixins: [searchMix]
}
</script>
